import { render, staticRenderFns } from "./DrugNFC.vue?vue&type=template&id=717fa972&"
import script from "./DrugNFC.vue?vue&type=script&lang=js&"
export * from "./DrugNFC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports